module.exports = __webpack_public_path__ + "img/unknown-avatar.540088d5.svg";